import React from 'react';
import { Link } from 'react-router-dom';

function Attribution() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Attribution & Open Source</h1>
        <p>
          OptiPathway is built upon the foundation of various robust open-source technologies and data. We extend our gratitude to the developers and communities behind these projects:
        </p>
        <ul>
          <li>
            <strong>OpenStreetMap (OSM):</strong> Our routing data is built using geographic data from OpenStreetMap, a collaborative project to create a free editable map of the world. The data is licensed under the Open Data Commons Open Database License (ODbL).
            Attribution: &copy; OpenStreetMap contributors.
            (<a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap Copyright and License</a>)
          </li>
          <li>
            <strong>Open Source Routing Machine (OSRM):</strong> The core routing engine used for calculating optimized routes. It processes OpenStreetMap data to provide fast and efficient route computations.
            (License: BSD 2-Clause License - <a href="https://github.com/Project-OSRM/osrm-backend/blob/master/LICENSE" target="_blank" rel="noopener noreferrer">Details</a>)
          </li>
          <li>
            <strong>React:</strong> The user interface is built using React, a JavaScript library for building user interfaces.
            (License: MIT License)
          </li>
          <li>
            <strong>React DOM:</strong> Provides the DOM-specific methods that enable React to interact with the browser's DOM.
            (License: MIT License)
          </li>
          <li>
            <strong>React Icons:</strong> Provides a collection of popular icons for React projects.
            (License: MIT License)
          </li>
          <li>
            <strong>React Router DOM:</strong> Enables declarative routing in React applications.
            (License: MIT License)
          </li>
          <li>
            <strong>Express:</strong> Fast, unopinionated, minimalist web framework for Node.js.
            (License: MIT License)
          </li>
          <li>
            <strong>Axios:</strong> Promise based HTTP client for the browser and node.js.
            (License: MIT License)
          </li>
          <li>
            <strong>Body-parser:</strong> Node.js body parsing middleware.
            (License: MIT License)
          </li>
          <li>
            <strong>CORS:</strong> Node.js CORS middleware.
            (License: MIT License)
          </li>
          <li>
            <strong>Nominatim:</strong> Geocoding service used to convert addresses into geographic coordinates.
            Data &copy; OpenStreetMap contributors.
          </li>
          <li>
            <strong>Geoapify:</strong> Geocoding and mapping services.
            Powered by <a href="https://www.geoapify.com/" target="_blank" rel="noopener noreferrer">Geoapify</a>.
          </li>
          <li>
            <strong>Node-Cache:</strong> A simple caching module for Node.js.
            (License: MIT License)
          </li>
          <li>
            <strong>P-Queue:</strong> Promise queue with concurrency control.
            (License: MIT License)
          </li>
          <li>
            <strong>JS-YAML:</strong> For parsing YAML configuration files.
            (License: MIT License)
          </li>
          <li>
            <strong>UUID:</strong> For generating unique IDs.
            (License: MIT License)
          </li>
          <li>
            <strong>Winston:</strong> A versatile logging library for Node.js.
            (License: MIT License)
          </li>
        </ul>
        <br />
        <Link to="/">Back to Optimizer</Link>
      </header>
    </div>
  );
}

export default Attribution;
